import Vue from "vue";
import Vuex from "vuex";
import { DateTime } from "luxon";
import jwtDecode from "jwt-decode";
import api from "./api";
import analysisApi from "./analysisApi";
import { actionTypes, commitTypes } from "./store-types";
import router from "./router";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		config: {
			lists: {},
		},
		syncError: false,
		batchTrackingNumbers: [],
		batchFailures: null,
		username: null,
		role: null,
		partnerId: null,
		appError: null,
		appLoaded: false,
		configLoaded: false,
		loggedIn: false,
		zone: DateTime.local().zoneName,
		toast: {
			color: "success",
			message: "",
		},
	},
	getters: {
		getConfig: state => state.config,
	},
	mutations: {
		[commitTypes.APP_STATE](state, val) {
			state.appLoaded = val;
		},
		[commitTypes.SET_LOGGEDIN](state, val) {
			state.loggedIn = val;
		},
		[commitTypes.SET_ERROR](state, val) {
			state.appError = val;
		},
		[commitTypes.SET_CONFIG](state, config) {
			state.config = config;
			state.configLoaded = true;
		},
		[commitTypes.SET_LISTS](state, lists) {
			state.config.lists = lists;
		},
		[commitTypes.SET_SYNC_ERROR](state, val) {
			state.syncError = val;
		},
		[commitTypes.SAVE_BATCH_NUMBERS](state, trackingNumbers) {
			state.batchTrackingNumbers = trackingNumbers;
		},
		[commitTypes.SAVE_BATCH_FAILURES](state, count) {
			state.batchFailures = count;
		},
		[commitTypes.SET_USERNAME](state, username) {
			state.username = username;
		},
		[commitTypes.SET_ROLE](state, role) {
			state.role = role;
		},
		[commitTypes.SET_PARTNER](state, id) {
			state.partnerId = id ? Number(id) : null;
		},
		[commitTypes.TOAST](state, val) {
			state.toast = val;
		},
		[commitTypes.SET_ZONE](state, val) {
			state.zone = val;
		},
	},
	actions: {
		[actionTypes.LOAD_CONFIG]({ commit }) {
			return api.app().then((r) => {
				commit(commitTypes.SET_CONFIG, r.data);
				analysisApi.setBase(r.data.analysisApiUrl);
			}).catch((e) => {
				commit(commitTypes.SET_ERROR, e);
			});
		},
		[actionTypes.SAVE_LOGIN]({ commit, dispatch }, token) {
			api.setJwt(token, () => { dispatch(actionTypes.CLEAR_LOGIN); });
			analysisApi.setJwt(token, () => { dispatch(actionTypes.CLEAR_LOGIN); });

			return api.appLists().then((r) => {
				commit(commitTypes.SET_LISTS, r.data);
			}).catch((e) => {
				commit(commitTypes.SET_ERROR, e);
			}).then(() => {
				window.localStorage.setItem("token", token);
				const decoded = jwtDecode(token);
				const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
				commit(commitTypes.SET_USERNAME, decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]);
				commit(commitTypes.SET_ROLE, role);
				commit(commitTypes.SET_PARTNER, decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/groupsid"]);
				commit(commitTypes.SET_LOGGEDIN, true);

				router.push(role === "Admin" ? { name: "transactions" } : { name: "applications" });
			});
		},
		[actionTypes.CLEAR_LOGIN]({ commit }) {
			api.setJwt(null, () => {});
			analysisApi.setJwt(null);
			window.localStorage.removeItem("token");
			commit(commitTypes.SET_USERNAME, null);
			commit(commitTypes.SET_ROLE, null);
			commit(commitTypes.SET_PARTNER, null);
			commit(commitTypes.SET_LISTS, {});
			commit(commitTypes.SET_LOGGEDIN, false);

			router.push({ name: "login" });
		},
		[actionTypes.CHECK_TOKEN]({ dispatch }) {
			const jwt = window.localStorage.getItem("token");

			if (!jwt) {
				return Promise.resolve();
			}
			return api.jwtCheck(jwt).then((r) => {
				if (r.status === 200) {
					return dispatch(actionTypes.SAVE_LOGIN, jwt);
				}

				return dispatch(actionTypes.CLEAR_LOGIN);
			}).catch(() => dispatch(actionTypes.CLEAR_LOGIN));
		},
		showState({ state }, label) {
			console.info(label);
			console.log(Object.assign({}, state));
		},
	},
});
